import z from 'zod';
import { siteSchema } from '../Site/schemas';
import { zoneSchema } from '../Zone/schemas';
import { createListApiSchema } from '../General/schemas';

export const deviceStatusSchema = z.enum(['unused', 'configured']);

export const deviceTypeSchema = z.enum(['kiosk', 'xs1', 'xs1/c', 'xs1/d', 'external']);

export const deviceDirectionSchema = z.enum(['in', 'out']);

export const devicePublicKeySchema = z.object({
	kty: z.string().optional(),
	n: z.string().optional(),
	e: z.string().optional(),
});

export const deviceSchema = z
	.object({
		id: z.string(),
		siteId: z.string().optional(),
		address: z.string().optional(),
		zoneLocationId: z.string().optional(),
		zoneId: z.string().optional(),
		name: z.string().optional(),
		description: z.string().optional(),
		hardwareId: z.string().optional(),
		status: deviceStatusSchema.default('unused'),
		setupKey: z.string().optional().nullable(),
		type: deviceTypeSchema.optional(),
		direction: deviceDirectionSchema.optional(),
		publicKey: devicePublicKeySchema.optional(),
		config: z.record(z.string(), z.any()).optional(),
		nodeActions: z.record(z.string(), z.any()).optional(),
		graph: z.record(z.string(), z.any()).optional(),
		services: z.array(z.string()).optional(),
		lastSeenAt: z.coerce.date().optional(),
		accessListValidity: z.record(z.string(), z.any()).optional(),
		hasError: z.boolean().optional(),
		inMaintenance: z.boolean().default(false),
		authToken: z.string().optional(),
		currentVersion: z.string().optional(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
		site: z.lazy(() => siteSchema).optional(),
		zone: z.lazy(() => zoneSchema).optional(),
		zoneLocation: z.lazy(() => zoneSchema).optional(),
		ioStatus: z.boolean().optional(),
		aclStatus: z.boolean().optional(),
		configStatus: z.boolean().optional(),
	})
	.describe('Device');

export const devicesApiResponseSchema = createListApiSchema(deviceSchema).describe('DeviceList');
